export const SET_LOGIN_TOKEN = 'SET_LOGIN_TOKEN';

/**
 * Set login token.
 * @function setLoginToken
 * @param {Object} token Token.
 * @returns {Object} Set login token results action.
 */
export function setLoginToken(token) {
  return {
    type: SET_LOGIN_TOKEN,
    result: { token }, 
  };
}
